import { action } from 'typesafe-actions';
import {
  AuthTypes,
  Auth,
  PartnerAuth,
  User,
  CentroDistribuicao,
  handleUpdateProfileProps,
  Depositantes,
} from './types';

export const loginRequest = (auth: Auth) => action(AuthTypes.LOGIN_REQUEST, { auth });
export const loginSuccess = (token: string, user: User) =>
  action(AuthTypes.LOGIN_SUCCESS, { token, user });
export const loginFailure = (errorMessage: string) =>
  action(AuthTypes.LOGIN_FAILURE, { errorMessage });

export const inscSelect = (inscricaoAtiva: any) =>
  action(AuthTypes.INSC_SELECT, { inscricaoAtiva });

export const depositanteSelect = (depositanteAtiva: Depositantes) =>
  action(AuthTypes.DEP_SELECT, { depositanteAtiva });

export const cddSelect = (cddAtivo: CentroDistribuicao | any) =>
  action(AuthTypes.CDD_SELECT, { cddAtivo });

export const updateRequest = (partnerAuth?: PartnerAuth) =>
  action(AuthTypes.UPDATE_REQUEST, { partnerAuth });
export const updateSuccess = (token: string) => action(AuthTypes.UPDATE_SUCCESS, { token });
export const updateFailure = (errorMessage: string) =>
  action(AuthTypes.UPDATE_FAILURE, { errorMessage });

export const passwordRequest = (username: string) =>
  action(AuthTypes.PASSWORD_REQUEST, { username });
export const passwordSuccess = (forgotPasswordMessage: string) =>
  action(AuthTypes.PASSWORD_SUCCESS, { forgotPasswordMessage });
export const passwordFailure = (errorMessage: string) =>
  action(AuthTypes.PASSWORD_FAILURE, { errorMessage });

export const resetPasswordRequest = (password: string, token: string) =>
  action(AuthTypes.PASSWORDRESET_REQUEST, { password, token });
export const resetPasswordSuccess = () => action(AuthTypes.PASSWORDRESET_SUCCESS, {});
export const resetPasswordFailure = (errorMessage: string) =>
  action(AuthTypes.PASSWORDRESET_FAILURE, { errorMessage });

export const logoutRequest = () => action(AuthTypes.LOGOUT_REQUEST, {});
export const logoutSuccess = () => action(AuthTypes.LOGOUT_SUCCESS, {});
export const logoutFailure = (errorMessage: string) =>
  action(AuthTypes.LOGOUT_FAILURE, { errorMessage });

export const cleanState = () => action(AuthTypes.CLEAN_STATE);

export const profileUpdateRequest = (profile: handleUpdateProfileProps) =>
  action(AuthTypes.UPDATE_PROFILE, { profile });
export const profileUpdateSuccess = (profile: handleUpdateProfileProps) =>
  action(AuthTypes.UPDATE_PROFILE_SUCCESS, { profile });
